import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useState } from "react";
import { Box, Button, Card, Tab, Tabs, Typography } from "@mui/material";

// import { useLazyGetPerformanceInsightsQuery } from "../../services/performace";
import moment from "moment";

// import CustomerDocuments from "../../features/users/CustomerDocuments";
// import ListedProducts from "../../features/agents/ListedProducts";
import Details from "../../features/users/Details";
import CustomerDocuments from "../../features/users/CustomerDocuments";
import ListedProducts from "../../features/agents/ListedProducts";
import SalesRevenue from "../../features/agents/SalesRevenue";
import useTranslation from "../../hooks/Translation";
// import SalesRevenue from "../../features/agents/SalesRevenue";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AgentDetail = () => {
  const location = useLocation();
  const { state } = location;
  const t = useTranslation();

  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const { _id } = useParams();
  // const [getData] = useLazyGetPerformanceInsightsQuery();

  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.main.vendorProfile}</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-vendors", { state: { value: state?.value } });
            }}
          >
            {t.main.back}
          </Button>
        </div>

        <Card className="cards">
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              {/* <Tab label="Manual Payouts" {...a11yProps(0)} /> */}
              <Tab label={t.main.profileDetails} {...a11yProps(0)} />
              <Tab label={t.main.docs} {...a11yProps(1)} />
              {/* <Tab label="Listed Products" {...a11yProps(2)} />
              <Tab label="Sales and revenue" {...a11yProps(3)} /> */}
              {/* <Tab label="Customer ratings and reviews" {...a11yProps(4)} /> */}
              {/* <Tab label="Token History" {...a11yProps(3)} />
              <Tab label="Reels" {...a11yProps(4)} />
              <Tab label="Transactions" {...a11yProps(5)} /> */}
              {/* {state?.insights === true ? (
                <Tab label="Titan Insights" {...a11yProps(6)} />
              ) : (
                ""
              )}
              {state?.insights === true ? (
                <Tab label="Overall Performance" {...a11yProps(7)} />
              ) : (
                ""
              )}
              {state?.insights === true ? (
                <Tab label="Listing Performance" {...a11yProps(8)} />
              ) : (
                ""
              )}
              {state?.insights === true ? (
                <Tab label="Leads Insights" {...a11yProps(9)} />
              ) : (
                ""
              )} */}
              {/* {state?.insights === true ? <Tab label="Super Agent Criteria" {...a11yProps(10)} /> : ""} */}
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <Details />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <CustomerDocuments />
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={2}>
              <ListedProducts />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <SalesRevenue />
            </CustomTabPanel> */}
          </Box>
        </Card>
      </div>
    </div>
  );
};

export default AgentDetail;
